'use client';

import { useState, useEffect, useMemo } from 'react';
import { Tab } from './Tab';
import { TabList } from './TabList';
import { TabPanel } from './TabPanel';
import { TabsContext } from './TabsContext';
import { cn, TabId, TabsProps, TabsVariant } from 'types';
export function Tabs({
  selectedTab,
  defaultTabId,
  children,
  variant = TabsVariant.NORMAL,
  className,
  GetActiveTabId = () => {},
}: Readonly<TabsProps>) {
  const [selectedTabId, setSelectedTabId] = useState<TabId>(selectedTab || defaultTabId);

  useEffect(() => {
    GetActiveTabId(selectedTabId);
  }, [selectedTabId]);

  useEffect(() => {
    if (selectedTab) setSelectedTabId(selectedTab);
  }, [selectedTab]);

  const contextValue = useMemo(
    () => ({
      selectedTabId,
      setSelectedTabId: (tabId: TabId): void => setSelectedTabId(tabId),
      variant,
    }),
    [selectedTabId, variant]
  );

  return (
    <div className={cn(className)}>
      <TabsContext.Provider value={contextValue}>
        <>{children}</>
      </TabsContext.Provider>
    </div>
  );
}

Tabs.Tab = Tab;
Tabs.TabList = TabList;
Tabs.TabPanel = TabPanel;
Tabs.displayName = 'Tabs';
